export interface TimezoneOption {
  iana: string;
  abbr: string;
  label: string;
}

export const TIMEZONE_OPTIONS: TimezoneOption[] = [
  { iana: 'UTC', abbr: 'UTC', label: 'UTC · Coordinated Universal Time' },
  { iana: 'America/New_York', abbr: 'ET', label: 'ET · Eastern Time (New York)' },
  { iana: 'America/Chicago', abbr: 'CT', label: 'CT · Central Time (Chicago)' },
  { iana: 'America/Denver', abbr: 'MT', label: 'MT · Mountain Time (Denver)' },
  { iana: 'America/Phoenix', abbr: 'MST', label: 'MST · Mountain Standard (Phoenix, no DST)' },
  { iana: 'America/Los_Angeles', abbr: 'PT', label: 'PT · Pacific Time (Los Angeles)' },
  { iana: 'America/Anchorage', abbr: 'AKT', label: 'AKT · Alaska Time' },
  { iana: 'Pacific/Honolulu', abbr: 'HST', label: 'HST · Hawaii Standard' },
  { iana: 'America/Toronto', abbr: 'ET', label: 'ET · Eastern Time (Toronto)' },
  { iana: 'America/Vancouver', abbr: 'PT', label: 'PT · Pacific Time (Vancouver)' },
  { iana: 'America/Mexico_City', abbr: 'CT', label: 'CT · Central Time (Mexico City)' },
  { iana: 'Europe/London', abbr: 'GMT/BST', label: 'GMT/BST · United Kingdom' },
  { iana: 'Europe/Dublin', abbr: 'GMT/IST', label: 'GMT/IST · Ireland' },
  { iana: 'Europe/Paris', abbr: 'CET', label: 'CET · Central European (Paris)' },
  { iana: 'Europe/Berlin', abbr: 'CET', label: 'CET · Central European (Berlin)' },
  { iana: 'Europe/Madrid', abbr: 'CET', label: 'CET · Central European (Madrid)' },
  { iana: 'Europe/Rome', abbr: 'CET', label: 'CET · Central European (Rome)' },
  { iana: 'Europe/Athens', abbr: 'EET', label: 'EET · Eastern European (Athens)' },
  { iana: 'Europe/Moscow', abbr: 'MSK', label: 'MSK · Moscow Time' },
  { iana: 'Asia/Dubai', abbr: 'GST', label: 'GST · Gulf Standard' },
  { iana: 'Asia/Kolkata', abbr: 'IST', label: 'IST · India Standard' },
  { iana: 'Asia/Bangkok', abbr: 'ICT', label: 'ICT · Indochina Time' },
  { iana: 'Asia/Singapore', abbr: 'SGT', label: 'SGT · Singapore Time' },
  { iana: 'Asia/Hong_Kong', abbr: 'HKT', label: 'HKT · Hong Kong' },
  { iana: 'Asia/Shanghai', abbr: 'CST', label: 'CST · China Standard' },
  { iana: 'Asia/Tokyo', abbr: 'JST', label: 'JST · Japan Standard' },
  { iana: 'Asia/Seoul', abbr: 'KST', label: 'KST · Korea Standard' },
  { iana: 'Australia/Perth', abbr: 'AWST', label: 'AWST · Western Australia' },
  { iana: 'Australia/Sydney', abbr: 'AET', label: 'AET · Eastern Australia (Sydney)' },
  { iana: 'Pacific/Auckland', abbr: 'NZT', label: 'NZT · New Zealand' },
];

const BY_IANA = new Map(TIMEZONE_OPTIONS.map((t) => [t.iana, t]));

export function getTimezoneOption(iana: string): TimezoneOption | null {
  return BY_IANA.get(iana) ?? null;
}

export function labelForTimezone(iana: string): string {
  return BY_IANA.get(iana)?.label ?? iana;
}

export function abbrForTimezone(iana: string): string {
  return BY_IANA.get(iana)?.abbr ?? iana;
}
